module.exports = __webpack_public_path__ + "img/low-emission-oxygen.2b7750ec.png";